var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-field',{class:_vm.classes,attrs:{"label":_vm.label}},[_vm._t("default",null,{"get":_vm.settings})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }